import { getUserInfo } from '@/api/api'
import { useRequest } from 'ahooks'
import React, { useState } from 'react'

const useUserInfo = () => {
  const [userInfo, setUserInfo] = useState('')
  const { run: fetchUserInfo, loading: userInfoLoading } = useRequest(
    getUserInfo,
    {
      manual: true,
      onSuccess(data: any) {
        setUserInfo(data)
      },
      onError(error: any) {},
    },
  )

  return { fetchUserInfo, userInfoLoading, userInfo }
}

export default useUserInfo
